import type { PrintoutColumnType } from "./types";

/**
 * Rendered cell text for a Name/Initials column when the row has no nurse (a gap placeholder).
 *
 * Purely a renderer-side concern: the sort key for the same row is `""` (mapping §5.5).
 */
export const MISSING_SHIFT_PLACEHOLDER = "---";

/**
 * Display value used when a row's horizontal-axis value can't be resolved
 * (e.g. a row with no location pivots into the "Unassigned" band).
 */
export const UNASSIGNED_PLACEHOLDER = "Unassigned";

/** Default column widths in Excel char units; `printoutColumnWidths` overrides in px (§2.1, §8.3). */
export const COLUMN_TYPE_TO_WIDTH: Record<PrintoutColumnType, number> = {
	location: 20,
	name: 20,
	certification: 12,
	shiftTime: 16,
	role: 12,
	notes: 24,
	initials: 12,
	floor: 12,
	scheduledHours: 10,
};

/** Default width (Excel char units) for the trailing Notes column when added via `printNotes`. */
export const DEFAULT_NOTES_COLUMN_WIDTH = 24;

/** Most blank columns a Detailed printout can append. Mirrors backend `PRINTOUT_MAX_APPEND_EMPTY_COLUMNS`. */
export const MAX_APPEND_EMPTY_COLUMNS = 10;

/** Default width (Excel char units) of each appended blank column, until the user drags it. */
export const DEFAULT_EMPTY_COLUMN_WIDTH = 16;

/** Header text for each column kind. The Role/Job duality is handled at the call site (mapping §5.2). */
export const COLUMN_TYPE_TO_HEADER: Record<PrintoutColumnType, string> = {
	location: "Location",
	name: "Name",
	certification: "Certification",
	shiftTime: "Shift Time",
	role: "Role",
	notes: "Notes",
	initials: "Initials",
	floor: "Floor",
	scheduledHours: "Scheduled Hours",
};
